import React from 'react';
import { AlertCircle, TrendingDown, Clock } from 'lucide-react';

const PainPoints = () => {
  const painPoints = [
    {
      icon: Clock,
      title: 'Delayed Deliveries',
      description: 'Missing delivery windows hurts customer trust and increases support tickets.'
    },
    {
      icon: () => (
        <div className="text-red-600 font-bold text-xl">₹</div>
      ),
      title: 'High Shipping Costs',
      description: 'Expensive shipping rates eat into your margins and reduce competitiveness.'
    },
    {
      icon: AlertCircle,
      title: 'Poor Visibility',
      description: 'Lack of real-time tracking leaves you and your customers in the dark.'
    },
    {
      icon: TrendingDown,
      title: 'Complex Integration',
      description: 'Difficult setup processes slow down your operations and waste valuable time.'
    }
  ];

  return (
    <section className="relative py-20 bg-white overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-blue-300 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-blue-800 font-semibold text-sm uppercase tracking-wide">The Problem</span>
          <h2 className="text-4xl font-bold mt-2 mb-4 text-gray-900">
            Traditional Shipping <span className="text-blue-800">Challenges</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We understand the frustrations eCommerce businesses face with logistics
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {painPoints.map((point, index) => {
            const Icon = point.icon;
            return (
              <div 
                key={index} 
                className="relative group p-6 bg-gradient-to-br from-gray-50 to-white rounded-2xl border border-gray-200 hover:border-blue-300 hover:shadow-xl transition-all duration-300"
              >
                {/* Decorative corner element */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-blue-100/50 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
                
                <div className="relative">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-red-200 transition-colors">
                    <Icon className="w-6 h-6 text-red-600" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{point.title}</h3>
                  <p className="text-gray-600 text-sm">{point.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PainPoints;